import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWithLoggingAndRetry } from '../../../store/middleware/thunk_helper';
import {
  getEmployerFormInfoByEmployerKey,
  submitEmployerAccessRequest,
  getBaseSlugSuggestions,
} from '../../../services/employerService';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

export const fetchBaseInfo = createAsyncThunkWithLoggingAndRetry(
  'baseUnauthed/fetchBaseInfo',
  ({ employerKey }, thunkAPI) => {
    return getEmployerFormInfoByEmployerKey(employerKey);
  }
);
export const submitAccessRequest = createAsyncThunkWithLoggingAndRetry(
  'baseUnauthed/submitAccessRequest',
  async ({ requestObj }, thunkAPI) => {
    return await submitEmployerAccessRequest(requestObj);
  }
);
export const fetchBaseSlugSuggestions = createAsyncThunkWithLoggingAndRetry(
  'baseUnauthed/fetchBaseSlugSuggestions',
  async ({ slug }, thunkAPI) => {
    return await getBaseSlugSuggestions(slug);
  }
);

const INITIAL_STATE = {
  baseInfoStatus: PENDING,
  inviteRequestStatus: PENDING,
  baseSlugSuggestionsStatus: PENDING,
  error: null,
  baseInfoData: null,
  savedFormData: null,
  baseSlugSuggestions: null,
};
const baseUnauthedSlice = createSlice({
  name: 'baseUnauthed',
  initialState: INITIAL_STATE,
  reducers: {
    resetState: (state) => {
      return {
        ...INITIAL_STATE,
        baseInfoStatus: state.baseInfoStatus,
        baseInfoData: state.baseInfoData,
        savedFormData: state.savedFormData,
      };
    },
    saveFormData: (state, action) => {
      state.savedFormData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBaseInfo.pending, (state) => {
        state.baseInfoStatus = REQUESTING;
        state.error = null;
      })
      .addCase(fetchBaseInfo.fulfilled, (state, action) => {
        state.baseInfoStatus = SUCCESS;
        state.error = null;
        state.baseInfoData = action.payload;
      })
      .addCase(fetchBaseInfo.rejected, (state, action) => {
        state.baseInfoStatus = FAILED;
        state.error = action.payload;
      })
      .addCase(submitAccessRequest.pending, (state) => {
        state.inviteRequestStatus = REQUESTING;
        state.error = null;
      })
      .addCase(submitAccessRequest.fulfilled, (state, action) => {
        state.inviteRequestStatus = SUCCESS;
        state.error = null;
      })
      .addCase(submitAccessRequest.rejected, (state, action) => {
        state.inviteRequestStatus = FAILED;
        state.error = action.payload;
      })
      .addCase(fetchBaseSlugSuggestions.pending, (state) => {
        state.baseSlugSuggestionsStatus = REQUESTING;
        state.error = null;
      })
      .addCase(fetchBaseSlugSuggestions.fulfilled, (state, action) => {
        state.baseSlugSuggestionsStatus = SUCCESS;
        state.error = null;
        state.baseSlugSuggestions = action.payload?.employers || null;
      })
      .addCase(fetchBaseSlugSuggestions.rejected, (state, action) => {
        state.baseSlugSuggestionsStatus = FAILED;
        state.error = action.payload;
      });
  },
});

export const { resetState, saveFormData } = baseUnauthedSlice.actions;
export default baseUnauthedSlice.reducer;
